import React from 'react';
import { getConfiguration } from '../../utils/configuration';
import { getFormattedTimestamp } from '../../utils/getFormattedTimestamp';
import { getCurrencyValue } from '../../utils/getCurrencyValue';
import { formatStringWithSpaces } from '../../utils/formatStringWithSpaces';
import ShopReceiptHeader from './common-includes/ShopReceiptHeader';
import ShopReceiptFooter from './common-includes/ShopReceiptFooter';
import { getLabel } from '../../../data/labels';
import QRCode from 'react-qr-code';


function RechargeAccountByVoucherReceipt(props) {
	const conf = getConfiguration();
	
	const additionalStyle = {
			"fontFamily" : "sans-serif",
			"fontSize" : "19px"
	};

	
	const opData = props.data;
	const operationTitle = getLabel('retail.account_recharge.by_voucher.title');
	const formattedTimestamp =  getFormattedTimestamp();
	const amountWithCurrency =  getCurrencyValue(opData.amn, conf.cs.m, conf.cs.nd, conf.cs.ct);	
	const id = formatStringWithSpaces(opData.id, 4);
	return (
		<body style={additionalStyle}>

			<ShopReceiptHeader customerLogo={props.customerLogo} aamsLogo={props.aamsLogo} operationTitle={operationTitle}></ShopReceiptHeader>
			
			<div>{getLabel('retail.date_time') + ": " + formattedTimestamp}</div>
			<div>{getLabel('retail.amount') + ": " + amountWithCurrency}</div>
			<div>{getLabel('retail.shop_pvend') + ": " + opData.shopId}</div>
			<div>{getLabel('retail.terminal_number') + ": " + opData.idTag}</div>
			<hr className="hr-line" />			
			<div className="qrcode-container" >
					<QRCode value={opData.id} size={90} />
		   </div>	
			<div className="centerText">{id}</div>
			<ShopReceiptFooter></ShopReceiptFooter>
		</body>
    );
}

export default RechargeAccountByVoucherReceipt;